import { RequestState, useRequestState } from '../../../hooks';
import { useGetApiClient } from '../../../context/apiContext';
import { postDestinationsRequest } from '@lt/api/dist/methods/widgets/types';
import { mapDestinationsOffersToDirectionItem } from '../helpers';
import type { DirectionWidgetItemProps } from '../components';

export const useGetWidgetsDestinations = (
  setData: (destinations: DirectionWidgetItemProps[], linkToExplore: string) => void
) => {
  const { setRequestState } = useRequestState();
  const api = useGetApiClient();

  const getWidgetsDestinations = async (params: postDestinationsRequest) => {
    setRequestState(RequestState.LOADING);
    try {
      const response = await api?.postWidgetsDestinations(params);
      if (!response?.offers) {
        return;
      }

      const destinations = mapDestinationsOffersToDirectionItem(response.offers, {
        adults: params.adults,
        kids: params.kids,
      });

      setData(destinations, response.link);
      setRequestState(RequestState.SUCCESS);
    } catch (e) {
      console.log('Error', e, params);
      setRequestState(RequestState.ERROR);
    }
  };
  return { getWidgetsDestinations };
};
